//angular imports
import { 
  Component, 
  EventEmitter, 
  computed, input, Output, signal, 
  OnDestroy, 
  TemplateRef,
  InputSignal,
  WritableSignal,
  ChangeDetectionStrategy
} from '@angular/core';

//local imports
import { IListItem } from '@shared/components/list/model/list-item';
import { SignalWrapper } from '@shared/signals/signal-wrapper';
import { Transforms } from '@shared/helpers/transforms';
import { debouncedSignal } from '@shared/signals/debounce.signal';


@Component({
  selector: "list",
  templateUrl: "./list.component.html",
  styleUrl: "./list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListComponent implements OnDestroy {
    
  public allowSelect = input(true, {
    transform: Transforms.toBoolean,
  });

  public allowMultiSelect = input(false, {
    transform: Transforms.toBoolean,
  });

  public filterEntities: InputSignal<WritableSignal<string>> =
    input<WritableSignal<string>>();

  public entities = input<IListItem[]>([]);
  public entityTitle = input<string>("");
  public label = input<string>("");
  public template = input<TemplateRef<any>>(null);
  public clippedSearch = input<boolean>(false);
  public clippedBody = input<boolean>(true);

  public searchValue = SignalWrapper.create({
    coreSignal: signal<string>(""),
    overrideSignalFn: (coreSignal) => debouncedSignal(coreSignal, 300),
  });

  @Output()
  public isEntitySelected = new EventEmitter<boolean>();

  @Output()
  public selectedEntity = new EventEmitter<IListItem>();

  public selectEntity(entity: IListItem) {
    if (!this.allowSelect()) return;
    if (!entity.isChecked) return;

    if (entity.isChecked()) {
      //remove selected entity from this.currentSelectedEntity      
      entity.select(false);

      this.isEntitySelected.emit(false);
      this.selectedEntity.emit(entity); //TODO:DIW:Should be selected entity changed.
      return;
    }

    let selectedEntities = this.selectedEntities();

    let value = this.allowMultiSelect();
    
    if (!value && selectedEntities.length > 0) {
      selectedEntities[0].select(false);      
    }
    
    entity.select(true);

    //TODO:DIW:Not sure both these will be needed..
    this.isEntitySelected.emit(true);
    this.selectedEntity.emit(entity);
  }

  public displayEntities = computed(() => {
    let searchValue = this.searchValue.overrideSignal();
    if (!searchValue) return this.entities();

    return this.entities()?.filter((item) =>
      ListComponent.searchCondition(item, searchValue),
    );
  });

  public selectedEntities = computed(() => 
    this.entities()?.filter((item) => item.isChecked && item.isChecked()));

  private static searchCondition(item: IListItem, val) {
    //TODO:DIW:Every entity shown in the list needs a searchable property.
    try {
      return item.name()?.toLowerCase().includes(val.toLowerCase());
    } catch (e) {
      console.error(e);
      return true;
    }
  }

  ngOnDestroy(): void {
    //unselect.
    // for (let entity of this.selectedEntities()) {
    //   if (entity.select) entity.select(false);
    // }
  }
}
